export default __webpack_public_path__ + "static/media/mic.cf579988.png";